<mb-base-modal>
  <div class="content" dialog-content>
    <div class="ics-confirmation copy-m">
      <h2 class="ics-confirmation-headline h3" translate="ICS_CONFIRMATION_HEADLINE"></h2>

      <div class="ics-confirmation-content">
        <span class="mb-icon mb-icon-calendar-date-add"></span>
        <div class="ics-confirmation-copy">
          {{ 'ICS_CONFIRMATION_COPY' | translate }}
          <div class="ics-confirmation-format-information">
            {{ 'FORMAT' | translate }}: {{ 'FORMAT_ICS' | translate }}
          </div>
        </div>
      </div>

      <div class="actions">
        <a
          class="btn btn-primary"
          [href]="icsLink"
          [target]="isMobile ? '_blank' : '_self'"
          download
          (click)="confirm.emit()"
          translate="SAVE"
        ></a>
        <button class="btn btn-tertiary" (click)="cancel.emit()" translate="CANCEL"></button>
      </div>
    </div>
  </div>
</mb-base-modal>
